import axios from '../../axios'

// 获取导入批次列表
export const getImportBatchList = (data) => {
    return axios({
        url: '/api/base/upload/batch',
        method: 'GET',
        data
    })
}


// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/importBatch.js